<template>
  <div id='bd-aside'>
    aside
  </div>
</template>

<script>
export default {
  name: 'bd-aside'

}
</script>

<style scoped>

</style>
